import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import styles from './UnlockRecordModal.module.scss'
import { format } from 'date-fns'

export type Props = {
    deadlineDate: Date
    onUnlock: () => void
}

export const UnlockRecordModal = () => {
    const { closeModal, props } = useModal<Props>()

    const handleUnlock = () => {
        if (!props) {
            return
        }

        props.onUnlock()
        closeModal()
    }

    if (!props) {
        return null
    }

    const formattedDate = format(props.deadlineDate, 'dd/MM/yyyy')

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>Unlock record?</h1>
                <p className={styles.description}>
                    <strong>{formattedDate}</strong> was the deadline for confirmation of this mileage with TfL. Are you
                    sure you want to unlock this record?
                </p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={closeModal}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" onClick={handleUnlock}>
                    Unlock
                </Button>
            </div>
        </Modal>
    )
}
